module.exports = __webpack_public_path__ + "img/stock7.644d32ec.png";